const axios = require("axios").default;

import mode from "./mode";

export default class dataService {
  constructor(dataPath) {
    this.dataPath = dataPath;
  }
  getMode() {
    return new Promise((resolve) => {
      axios
        .get(`${process.env.VUE_APP_DATA_URL}${this.dataPath}/mode.json`)
        .then((response) => {
          switch (response.data.mode) {
            case "artist":
              resolve(mode.ByArtistMode);
              break;
            case "headliner":
              resolve(mode.ByHeadlinerMode);
              break;
            case "day":
              resolve(mode.ByDayMode);
              break;
            case "full":
              resolve(mode.FullMode);
              break;
            default:
              console.error(
                "unable to determine view mode, defaulting to artist only"
              );
              resolve(mode.ByArtistMode);
              break;
          }
        });
    });
  }
  getArtistsData() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_DATA_URL}${this.dataPath}/artists.json`)
        .then((response) => {
          const dataPath = this.dataPath;
          const artists = [];
          for (let prop in response.data) {
            // eslint-disable-next-line
            if (response.data.hasOwnProperty(prop)) {
              const key = response.data[prop];
              artists.push({
                id: key._id,
                title: key.title,
                photo: key.photo_suffix,
                detail: undefined,
                billingOrder: key.billingOrder ? key.billingOrder : 0,
                getDetail: function () {
                  return axios
                    .get(
                      `${process.env.VUE_APP_DATA_URL}${dataPath}/${key._id}.json`
                    )
                    .then((response) => {
                      this.detail = response.data;
                    })
                    .catch((err) => {
                      console.error(err);
                      console.error(`no data found for key ${key._id}`);
                    });
                },
              });
            }
          }
          resolve(artists);
        })
        .catch((err) => {
          console.error("error getting artists!");
          reject(err);
        });
    });
  }
  getShowsData() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_DATA_URL}${this.dataPath}/shows.json`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          console.error("error getting shows!");
          reject(err);
        });
    });
  }
}
